import React, { Component } from 'react'
import { connect } from 'react-redux'

class StandaloneFilter extends Component {
  render () {
    if (!this.props.filter) return null
    return (
      <div className={(this.props.filter ? 'standalone-search-wrapper' : 'hidden') + ' hidden-xs'}>
        <div className='form-group standalone-search-form-group'>
          <i className='fa fa-search' />
          <input
            autoFocus
            type='text'
            className='form-control'
            id='standalone-search-input'
            onChange={e => this.props.filter(e)}
            onKeyUp={e => this.props.filter(e)} />
        </div>
      </div>
    )
  }
}
// eslint-disable-next-line
StandaloneFilter = connect(state => state)(StandaloneFilter)
export default StandaloneFilter



// WEBPACK FOOTER //
// ./src/components/basic/misc/StandaloneFilter.js